


































































import {
  AccountManagerAccountDTO,
  AccountManagerService,
  RoleService,
} from "@/common/api";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import AccountEditComponent from "@/components/admin/account/accountEditComponent.vue";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "AccountListComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    AccountEditComponent,
  },
})
export default class AccountListComponent extends Vue {

  public search = {
    sort: "created_at",
    direction: "desc",
    keyword: "",
    perPage: 30,
    page: 1,
  };

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public headers = [
    { id: "created_at", name: "作成日", order: "desc" },
    { id: "name", name: "ユーザー名", order: "" },
    { id: "authority", name: "権限" },
    { id: "email", name: "メールアドレス" },
    { id: "is_viewable", name: "スタッフ表示", order: "" },
    { id: "", name: "" },
  ];

  public accounts: AccountManagerAccountDTO[] = null;

  public keyword = "";

  public roles = [];
  public showEditPopup(id = null) {
    (this.$refs.accountEditPopup as AccountEditComponent).show(id);
  }

  public mounted() {
    this.filter();
    this.getRoles();
  }

  public reset(): void {
    this.search = {
      sort: "created_at",
      direction: "desc",
      keyword: "",
      perPage: 30,
      page: 1,
    };
    this.doSearch();
  }

  public filter(): void {
    const query = this.$router.currentRoute.query;
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    query = {
      ...this.search,
      ...query,
    };

    this.$router.push({ query }).catch(() => {
      //
    });

    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    const result = await AccountManagerService.adminAccount(query);

    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });

    this.accounts = result.data.accounts;
  }

  public async getRoles() {
    const result = await RoleService.adminRole({});
    this.roles = result.data.roles;
  }
}
